export const FIELD_PATTERNS = {
    TRAVEL_CARD: (min: number, max: number) => `^(\\d{${min}}|\\d{${max}})$`,
    BANK_ACCOUNT: '(\\d{4}\\.\\d{2}\\.\\d{5}|\\d{4}\\s\\d{2}\\s\\d{5}|\\d{11})',
    TIME: '^(?:(?:[0-1]{0,1}[0-9])|(?:2[0-3])):[0-5]{0,1}[0-9]$',
    APP_ID: '^[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{2}$',
    EMAIL: "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$",
    FOUR_DIGIT_VALIDATION: '^[0-9]{4}$',
    REFUND_AMOUNT: '^([0-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9]|[1-9][0-9][0-9][0-9][0-9]|100000)$',
    CAPITAL_LETTER: '[A-Z]',
    ONLY_NUMERIC_KEY: '^\\d$'
};

export const DEFAULT_COUNTRY = {
    CODE: 'NO',
    NAME: 'Norway',
    PHONE_CODE: '+47'
};

export const PASSWORD_MIN_LENGTH = 9;

export const FIELD_MASK = {
    APP_ID: (ch: string) => `${ch.repeat(4)}-${ch.repeat(4)}-${ch.repeat(2)}`,
    BANK_ACCOUNT: (ch: string) => `${ch.repeat(4)}.${ch.repeat(2)}.${ch.repeat(5)}`,
    TIME: (h: string, m: string) => `${h.repeat(2)}:${m.repeat(2)}`
};

export const FIELD_TYPES = {
    PASSWORD: 'password',
    PHONE: 'phone'
};

export const RECAPTCHA_ACTIONS = {
    CREATE_PROFILE: 'createprofile',
    CREATE_ISSUE: 'createissue',
    CONFIRM_PHONE: 'confirmphone',
    VERIFY_CONFIRM_PHONE: 'verifyconfirmphone'
};
